import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Switch from 'react-switch';
import cn from 'classnames';
import SelectOption from '../General/SelectOption';
import Tooltip from '../General/Tooltip';
import { SEGMENT_OPTIONS } from '../../helpers/discover_helpers';
import './DiscoverControls.scss';

const DiscoverControls = ({
  selectedSortOption, groupedSortOptions, onSortChange,
  minAffinity, minAffinityOptions, onMinAffinityChange,
  selectedSegments, onSegmentToggle,
  viewMode, onViewModeChange,
  vibeActive, hidePartialMatches, onHidePartialMatchesToggle
}) => {
  return (
    <div className='discover-filters-sticky'>
      <div className='filter-row'>
        <div className='sort-control'>
          <div className='sort-label'>Sort By</div>
          <Select
            className='select'
            classNamePrefix='select'
            value={selectedSortOption}
            options={groupedSortOptions}
            onChange={onSortChange}
            components={{ Option: SelectOption }}
            isSearchable={false}
          />
        </div>
        <div className='sort-control'>
          <div className='sort-label'>Min Brand Match Score</div>
          <Select
            className='select'
            classNamePrefix='select'
            value={minAffinityOptions.find(o => o.value === minAffinity)}
            options={minAffinityOptions}
            onChange={onMinAffinityChange}
            isSearchable={false}
          />
        </div>
        <div className='sort-control'>
          <div className='sort-label'>View</div>
          <div className='view-mode-buttons'>
            <button
              className={cn('view-mode-btn', { active: viewMode === 'list' })}
              onClick={() => onViewModeChange('list')}
            >
              List
            </button>
            <button
              className={cn('view-mode-btn', { active: viewMode === 'category' })}
              onClick={() => onViewModeChange('category')}
            >
              By top category
            </button>
          </div>
        </div>
      </div>
      <div className='segment-toggles'>
        {SEGMENT_OPTIONS.map(seg => {
          const isActive = selectedSegments.includes(seg.value);
          return (
            <div key={seg.value} className='radio-toggle control'>
              <div className={cn('radio-toggle-label label', { active: isActive })}>
                {seg.label}
              </div>
              <Switch
                onChange={() => onSegmentToggle(seg.value)}
                checked={isActive}
                height={14}
                width={20}
                onColor='#333'
                offColor='#ccc'
                checkedIcon={false}
                uncheckedIcon={false}
              />
            </div>
          );
        })}
        {/* Vibe-only: evidence (and thus partial-match info) exists only on vibe hits. */}
        {vibeActive && (
          <div className='radio-toggle control hide-partial-toggle'>
            <Tooltip message="Partial matches meet only some of your search criteria — each card's 'not …' notes show what's missing. Turn on to show only creators matching every criterion.">
              <div className={cn('radio-toggle-label label', { active: hidePartialMatches })}>
                Hide partial matches
              </div>
            </Tooltip>
            <Switch
              onChange={onHidePartialMatchesToggle}
              checked={!!hidePartialMatches}
              height={14}
              width={20}
              onColor='#333'
              offColor='#ccc'
              checkedIcon={false}
              uncheckedIcon={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

DiscoverControls.propTypes = {
  selectedSortOption: PropTypes.object,
  groupedSortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSortChange: PropTypes.func.isRequired,
  minAffinity: PropTypes.number,
  minAffinityOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onMinAffinityChange: PropTypes.func.isRequired,
  selectedSegments: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSegmentToggle: PropTypes.func.isRequired,
  viewMode: PropTypes.string.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  vibeActive: PropTypes.bool,
  hidePartialMatches: PropTypes.bool,
  onHidePartialMatchesToggle: PropTypes.func,
};

export default DiscoverControls;
